<template>
  <div>
    <!-- Fixed Sidebar Left -->

    <div class="fixed-sidebar fixed-sidebar-responsive">
      <div class="fixed-sidebar-left sidebar--small" id="sidebar-left-responsive">
        <router-link to="/" class="logo js-sidebar-open">
          <img src="/image/logos/logo_darker_blue.png" :alt="projectName" />
        </router-link>
      </div>

      <div class="fixed-sidebar-left sidebar--large" id="sidebar-left-1-responsive">
        <router-link class="logo" to="/">
          <div class="img-wrap">
            <img src="/image/logos/logo_darker_blue.png" :alt="projectName" />
          </div>
          <div class="title-block">
            <h6 class="logo-title">{{projectName}}</h6>
          </div>
        </router-link>

        <div class="mCustomScrollbar" data-mcs-theme="dark">
          <div v-if="signedIn === true" class="control-block">
            <div class="author-page author vcard inline-items">
              <div class="author-thumb">
                <img alt="author" :src="getAvatarLocal()" style="width: 60px;height:57px" class="avatar" />
                <span class="icon-status online"></span>
              </div>
              <router-link class="author-name fn" to="#">
                <div class="author-title">
                  {{  userName() }}
                  <svg class="olymp-dropdown-arrow-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-dropdown-arrow-icon" />
                  </svg>
                </div>
                <span class="author-subtitle" v-if=" $store.state.user.user_type === '1' && $store.state.user.club === null ">No Club</span>
                <span class="author-subtitle" v-else>{{$store.state.user.club}}</span>
              </router-link>
            </div>
          </div>
          <div v-else>
            <a
              href="#"
              class="btn btn-primary mt-1 btn-block"
              data-toggle="modal"
              data-target="#registration-login-form-popup"
            >Join</a>
          </div>

          <ul class="left-menu">
            <li>
              <a href="#" class="js-sidebar-open">
                <svg class="olymp-close-icon left-menu-icon">
                  <use xlink:href="svg-icons/sprites/icons.svg#olymp-close-icon" />
                </svg>
                <span class="left-menu-title">Collapse Menu</span>
              </a>
            </li>
          </ul>

          <div v-if="signedIn === true" class="ui-block-title ui-block-title-small">
            <h6 class="title">YOUR ACCOUNT</h6>
          </div>

          <ul v-if="signedIn === true" class="account-settings">
            <li>
              <router-link :to="'/profile/' + getUserDetails.username ">
                <svg class="olymp-menu-icon">
                  <use xlink:href="svg-icons/sprites/icons.svg#olymp-menu-icon" />
                </svg>
                <span>Profile</span>
              </router-link>
            </li>
            <li>
              <router-link v-if="getUserDetails.user_type === '2' " to="/Deals">
                <svg
                  class="olymp-star-icon left-menu-icon"
                >
                  <use xlink:href="svg-icons/sprites/icons.svg#olymp-football-icon" />
                </svg>

                <span>Deals</span>
              </router-link>
            </li>
            <li>
              <a href="#">
                <svg class="olymp-logout-icon">
                  <use xlink:href="svg-icons/sprites/icons.svg#olymp-logout-icon" />
                </svg>

                <span @click="setLogout(true)">Log Out</span>
              </a>
            </li>
          </ul>

          <!-- <div class="ui-block-title ui-block-title-small">
				<h6 class="title">About {{projectName}}</h6>
			</div>

			<ul class="about-olympus">
				<li>
					<a href="#">
						<span>Terms and Conditions</span>
					</a>
				</li>
				<li>
					<a href="#">
						<span>FAQs</span>
					</a>
				</li>
				<li>
					<a href="#">
						<span>Careers</span>
					</a>
				</li>
				<li>
					<a href="#">
						<span>Contact</span>
					</a>
				</li>
          </ul>-->
        </div>
      </div>
    </div>

    <!-- ... end Fixed Sidebar Left -->

    <!-- Header-BP -->

    <header class="header" id="site-header">
      <div class="page-title">
        <div class="img-wrap" style="width:150px;float:left;margin-top:-18px;margin-right:20px;">
          <router-link to="/">
            <img style="width: 70px;" src="/image/logos/logo_blue.png" alt="Match Day Deals" />
          </router-link>
        </div>
      </div>

      <div class="header-content-wrapper">
        <!-- <form class="search-bar w-search notification-list friend-requests">
                    <div class="form-group with-button">
                        <input class="form-control js-user-search" placeholder="Search here for clubs or deals..." type="text">
                        <button>
                            <svg class="olymp-magnifying-glass-icon"><use xlink:href="/svg-icons/sprites/icons.svg#olymp-magnifying-glass-icon"></use></svg>
                        </button>
                    </div>
        </form>-->

        <a data-toggle="modal" @click="() => { whereto = true }" data-target="#faqs-popup" href="javascript:;" id="whatmatch" class="btn btn-secondary btn-sm" style="display:none;position:relative;top:4px;left: 40px;border-radius: 70px;background-color: #fff;border: none;box-shadow: 0 4px 8px rgba(0,0,0,.2);">
                    <h6 style="color:#444;font-weight:bold">What match ?
                        <svg class="olymp-dropdown-arrow-icon" style="fill:#38a9ff;position: relative;top:7px;left:4px;width: 17px;"><use xlink:href="/svg-icons/sprites/icons.svg#olymp-dropdown-arrow-icon"></use></svg>
                    </h6>
        </a>

        <div class="control-block">
          <div
            v-if="signedIn === true"
            @click="emitReviewBox()"
            class="control-icon more has-items"
          >
            <svg class="olymp-plus-icon">
              <use xlink:href="/svg-icons/sprites/icons.svg#olymp-plus-icon" />
            </svg>
            <div class="label-description">Post</div>
          </div>
          <router-link :to="{name: 'Deals'}" v-if="signedIn === true && getUserDetails.user_type !== '1' " class="control-icon more has-items">
            <svg class="olymp-football-icon">
              <use xlink:href="/svg-icons/sprites/icons.svg#olymp-football-icon" />
            </svg>
            <div class="label-description">Deals</div>
          </router-link>

          <topNotifications />
          <topRightNav />
        </div>
      </div>
    </header>

    <!-- ... end Header-BP -->

    <!-- Responsive Header-BP -->

    <header class="header header-responsive" id="site-header-responsive">
      <div class="header-content-wrapper">
        <ul class="nav nav-tabs mobile-app-tabs" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link"
              href="javascript:;"
              data-toggle="modal"
              :data-target=" this.$route.params.fixture_id ? '#edit-my-poll-popup' : '' "
              v-if="signedIn === true"
              @click="emitReviewBoxx()"
            >
              <div class="control-icon has-items">
                <svg class="olymp-plus-icon">
                  <use xlink:href="/svg-icons/sprites/icons.svg#olymp-plus-icon" />
                </svg>
              </div>
            </a>
          </li>

          <li class="nav-item">
            <span
              v-if="signedIn === true && getUserDetails.user_type !== '1' "
              @click="emitDealsBox()"
              class="nav-link"
            >
              <div class="control-icon has-items">
                <svg class="olymp-football-icon">
                  <use xlink:href="/svg-icons/sprites/icons.svg#olymp-football-icon" />
                </svg>
              </div>
            </span>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              v-if="signedIn === true"
              data-toggle="tab"
              href="#notification"
              role="tab"
            >
              <div class="control-icon has-items">
                <svg class="olymp-chat---messages-icon">
                  <use xlink:href="/svg-icons/sprites/icons.svg#olymp-chat---messages-icon" />
                </svg>
                <div class="label-avatar bg-primary">{{ notifications_count }}</div>
              </div>
            </a>
          </li>

          <!-- <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#search" role="tab">
                            <svg class="olymp-magnifying-glass-icon"><use xlink:href="/svg-icons/sprites/icons.svg#olymp-magnifying-glass-icon"></use></svg>
                            <svg class="olymp-close-icon"><use xlink:href="/svg-icons/sprites/icons.svg#olymp-close-icon"></use></svg>
                        </a>
          </li>-->
        </ul>
      </div>

      <!-- Tab panes -->
      <div class="tab-content tab-content-responsive">
        <div class="tab-pane" id="notification" role="tabpanel">
          <div class="mCustomScrollbar" data-mcs-theme="dark">
            <div class="ui-block-title ui-block-title-small">
              <h6 class="title">Notifications</h6>
              <a href="#" v-if="notifications_count > 0">Mark all as read</a>
              <a href="#" v-if="notifications_count > 0">Settings</a>
            </div>
            <ul v-if="notifications_count < 1" class="notification-list">
              <div style="padding: 30px;text-align:center" class="comment-photo">
                <img width="220" src="/img/404.png" />
                <span style="font-size:20px">“You have no notification here”</span>
              </div>
            </ul>
            <ul v-else class="notification-list">
              <li>
                <div class="author-thumb">
                  <img src="img/avatar62-sm.jpg" alt="author" />
                </div>
                <div class="notification-event">
                  <div>
                    <a href="#" class="h6 notification-friend">Mathilda Brinker</a> commented on your new
                    <a href="#" class="notification-link">profile status</a>.
                  </div>
                  <span class="notification-date">
                    <time class="entry-date updated" datetime="2004-07-24T18:18">4 hours ago</time>
                  </span>
                </div>
                <span class="notification-icon">
                  <svg class="olymp-comments-post-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-comments-post-icon" />
                  </svg>
                </span>

                <div class="more">
                  <svg class="olymp-three-dots-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-three-dots-icon" />
                  </svg>
                  <svg class="olymp-little-delete">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-little-delete" />
                  </svg>
                </div>
              </li>

              <li class="un-read">
                <div class="author-thumb">
                  <img src="img/avatar63-sm.jpg" alt="author" />
                </div>
                <div class="notification-event">
                  <div>
                    You and
                    <a href="#" class="h6 notification-friend">Nicholas Grissom</a> just became friends. Write on
                    <a href="#" class="notification-link">his wall</a>.
                  </div>
                  <span class="notification-date">
                    <time class="entry-date updated" datetime="2004-07-24T18:18">9 hours ago</time>
                  </span>
                </div>
                <span class="notification-icon">
                  <svg class="olymp-happy-face-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-happy-face-icon" />
                  </svg>
                </span>

                <div class="more">
                  <svg class="olymp-three-dots-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-three-dots-icon" />
                  </svg>
                  <svg class="olymp-little-delete">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-little-delete" />
                  </svg>
                </div>
              </li>

              <li class="with-comment-photo">
                <div class="author-thumb">
                  <img src="img/avatar64-sm.jpg" alt="author" />
                </div>
                <div class="notification-event">
                  <div>
                    <a href="#" class="h6 notification-friend">Sarah Hetfield</a> commented on your
                    <a href="#" class="notification-link">photo</a>.
                  </div>
                  <span class="notification-date">
                    <time class="entry-date updated" datetime="2004-07-24T18:18">Yesterday at 5:32am</time>
                  </span>
                </div>
                <span class="notification-icon">
                  <svg class="olymp-comments-post-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-comments-post-icon" />
                  </svg>
                </span>

                <div class="comment-photo">
                  <img src="img/comment-photo1.jpg" alt="photo" />
                  <span>“She looks incredible in that outfit! We should see each...”</span>
                </div>

                <div class="more">
                  <svg class="olymp-three-dots-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-three-dots-icon" />
                  </svg>
                  <svg class="olymp-little-delete">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-little-delete" />
                  </svg>
                </div>
              </li>

              <li>
                <div class="author-thumb">
                  <img src="img/avatar65-sm.jpg" alt="author" />
                </div>
                <div class="notification-event">
                  <div>
                    <a href="#" class="h6 notification-friend">Green Goo Rock</a> invited you to attend to his event Goo in
                    <a
                      href="#"
                      class="notification-link"
                    >Gotham Bar</a>.
                  </div>
                  <span class="notification-date">
                    <time class="entry-date updated" datetime="2004-07-24T18:18">March 5th at 6:43pm</time>
                  </span>
                </div>
                <span class="notification-icon">
                  <svg class="olymp-happy-face-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-happy-face-icon" />
                  </svg>
                </span>

                <div class="more">
                  <svg class="olymp-three-dots-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-three-dots-icon" />
                  </svg>
                  <svg class="olymp-little-delete">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-little-delete" />
                  </svg>
                </div>
              </li>

              <li>
                <div class="author-thumb">
                  <img src="img/avatar66-sm.jpg" alt="author" />
                </div>
                <div class="notification-event">
                  <div>
                    <a href="#" class="h6 notification-friend">James Summers</a> commented on your new
                    <a href="#" class="notification-link">profile status</a>.
                  </div>
                  <span class="notification-date">
                    <time class="entry-date updated" datetime="2004-07-24T18:18">March 2nd at 8:29pm</time>
                  </span>
                </div>
                <span class="notification-icon">
                  <svg class="olymp-heart-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-heart-icon" />
                  </svg>
                </span>

                <div class="more">
                  <svg class="olymp-three-dots-icon">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-three-dots-icon" />
                  </svg>
                  <svg class="olymp-little-delete">
                    <use xlink:href="svg-icons/sprites/icons.svg#olymp-little-delete" />
                  </svg>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="tab-pane" id="search" role="tabpanel">
          <form class="search-bar w-search notification-list friend-requests">
            <div class="form-group with-button">
              <input
                class="form-control js-user-search"
                placeholder="Search here people or pages..."
                type="text"
              />
            </div>
          </form>
        </div>
      </div>
      <!-- end  Tab panes -->
    </header>

    <!-- ... end Responsive Header-BP -->
    <AuthModal />
     <reviewBoxHeader />
    <dealsBox />
  </div>
</template>

<script>
import { mapState } from "vuex";
import AuthModal from "@/components/AuthModal";
// import jquery from "jquery";
import topRightNav from "@/components/topRightNav";
import topNotifications from "@/components/topNotifications";
import reviewBoxHeader from "@/components/Modals/reviewSystems/reviewBoxHeader";
import dealsBox from "@/components/Modals/dealsSystem/dealBox";
import avta from "@/functions/getAvatar";
import ls from "../localstorage";

var pageData = {
  projectName: "",
  userData: {},
  id: null,
  avatar: "",
  signedIn: false,
  user_type: "",
  notifications_count: 0
};

export default {
  name: "Header",
  data() {
    return pageData;
  },
  computed: {
    ...mapState(["fansData", "user"]),
    getUserDetails() {
      return this.user;
    },
    getUsername() {
      return this.user.username;
    },
    getAvatar() {
      return this.user.avatar;
    },
  },
  components: { AuthModal, topRightNav, topNotifications, reviewBoxHeader, dealsBox },
  methods: {
    userName() {

      if (ls.checkStorage("fansData")) {
        var userData = ls.getStorage("fansData");
        if (userData[0].user_type === '1') {
          return userData[0].username;
        }else {
          return userData[0].business_name;
        }
      }else {
        if (this.$store.state.user.user_type === '1') {
          return this.$store.state.user.username;
        }else {
          return this.$store.state.fansData[0].business_name
        }
      }
    },
    getAvatarLocal() {
      // var userData = localStorage.fansData;
      return avta({state:{ av: this.getAvatar, us: this.getUsername }});
    },
    // set logout
    setLogout(val) {
      if(val === true) {
        window.eventBus.$emit("logout", val);
      }
    },
    setMatchId() {},
    checkUserData(userData) {
      if (userData !== "" || userData !== "undefined") {
        this.userData = JSON.parse(userData);
        this.signedIn = true;
      }
    },
    emitReviewBox() {
      window.eventBus.$emit("reviewBox", true);
    },
    emitDealsBox() {
      window.eventBus.$emit("dealsBox", true);
      // console.log('Clicked for deals');
    },
    emitReviewBoxx() {
      var matchId = this.$route.params.fixture_id;
      if (matchId) {
        window.eventBus.$emit("matchID", matchId);
      } else {
        // window.eventBus.$emit("reviewBoxHeader", true);
        window.eventBus.$emit("reviewBox", true);
      }
    },
  },
  mounted() {
    var userData = localStorage.fansData;

    if (userData) {
      this.checkUserData(userData);
    }

    window.eventBus.$on("nowhereto", id => {
      this.whereto = id;
    });

    this.projectName = this.$store.state.projectName;
    // var $ = jquery;
    $(window).scroll(function(){
      if ($(window).scrollTop() >= 300) {
        $('#whatmatch').show();
      }
      else {
        $('#whatmatch').hide();
      }
    });

    var $window = $(window),
            $document = $(document),
            $body = $("body"),
            $sidebar = $(".fixed-sidebar");

    /* -----------------------------
	 * Toggle functions
	 * ---------------------------*/

    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      var target = $(e.target).attr("href"); // activated tab
      if('#events' === target){
        $('.fc-state-active').click();
      }
    });

    // Toggle aside panels
    $(".js-sidebar-open").on('click', function () {
      $(this).toggleClass('active');
      $('.fixed-sidebar').toggleClass('open');
      return false;
    });

    // Close on "Esc" click
    $window.keydown(function (eventObject) {
      if (eventObject.which == 27 && $sidebar.is(':visible')) {
        $sidebar.removeClass('open');
      }
    });

    // Close on click outside elements.
    $document.on('click', function (event) {
      if (!$(event.target).closest($sidebar).length && $sidebar.is(':visible')) {
        $sidebar.removeClass('open');
      }
    });

  },
};
</script>

<style>
.btn-smoke-white {
  color: #29ac17;
  background-color: #fff;
}
.btn-smoke-white:hover {
  color: #444;
}
/* .search-bar.w-search {
    background-color: #29ac17 !important;
} */
.fixed-sidebar .logo {
  /*padding: 0;*/
}
.logo .img-wrap {
  height: 100% !important;
}
.logo img {
  height: 100% !important;
}
.fixed-sidebar .logo {
  background-color: #00AEEF;
}
.header .page-title > * {
  color: #00AEEF;
}
.control-icon.has-items {
  fill: #000;
}
.control-block .author-title {
  color: #00AEEF;
}
.header {
  background-color: #fff;
}
.search-bar .form-group.with-button input {
  color: #000;
  /* border:solid 1px #999; */
}
.search-bar.w-search {
  width: 500px;
  min-height: 70px;
  background-color: #d6d6d6;
}
.search-bar .form-group.with-button button {
  color: #696d87;
  fill: #696d87;
  background-color: #d6d6d6;
  width: 50px;
}
.header.switched {
  background-color: #3f4257;
}
.switched .control-icon.has-items {
  fill: #fff;
}
.switched .control-icon.has-items .olymp-football-icon {
  fill: #000;
}
.switched .control-block .author-title {
  color: #fff;
}
</style>
